import * as Yup from "yup";

export function initialValues(subject) {
  return {
    name: subject?.name || "",
    icon: subject?.icon || "",
    mobileIcon: subject?.mobileIcon || "",
  };
}

export function validationSchema() {
  return Yup.object({
    name: Yup.string().required("El nombre es obligatorio"),
    icon: Yup.string().required("El ícono web es obligatorio"),
    mobileIcon: Yup.string().required("El ícono móvil es obligatorio"),
  });
}
